var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('svg', {
    class: _vm.$style.logoImage,
    attrs: {
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "133 283 576 30"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "linear-gradient",
      "x1": "586.8",
      "x2": "643.6",
      "y1": "297.6",
      "y2": "297.6",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#812990"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#89268f"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".2",
      "stop-color": "#a31f8e"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".3",
      "stop-color": "#b61a8d"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".4",
      "stop-color": "#c2178d"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": ".6",
      "stop-color": "#c6168d"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#ed1c24"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient1",
      "x1": "134.2",
      "x2": "534.2",
      "y1": "297.8",
      "y2": "297.8",
      "href": "#linear-gradient"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient2",
      "x1": "134.2",
      "x2": "534.2",
      "y1": "297.8",
      "y2": "297.8",
      "href": "#linear-gradient"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient3",
      "x1": "134.2",
      "x2": "534.2",
      "y1": "297.8",
      "y2": "297.8",
      "href": "#linear-gradient"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient4",
      "x1": "134.2",
      "x2": "534.2",
      "y1": "297.8",
      "y2": "297.8",
      "href": "#linear-gradient"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient5",
      "x1": "134.2",
      "x2": "534.2",
      "y1": "297.8",
      "y2": "297.8",
      "href": "#linear-gradient"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient6",
      "x1": "134.2",
      "x2": "534.2",
      "y1": "297.8",
      "y2": "297.8",
      "href": "#linear-gradient"
    }
  })], 1), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "m590 305.1-1.9-1c-.3-.2-.7 0-.7.4v5.9c0 .3.2.5.5.5h1.9c.3 0 .5-.2.5-.5v-4.9c0-.2 0-.3-.2-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "M590.2 293.5c-.2-1.9-.9-3.6-2.1-5-.2-.2-.3-.4-.5-.6-.3-.3-.8 0-.8.3v5.3c0 .3.2.5.5.5h2.5c.3 0 .5-.2.5-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "M591.5 285.4c-.3-.2-.7 0-.7.4v7.8c0 .3.2.5.5.5h2.5c.3 0 .5-.2.5-.5v-6.2c0-.1 0-.3-.2-.4-.8-.6-1.6-1.2-2.6-1.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "m594.1 303.6-2.5-1.4c-.3-.2-.7 0-.7.4v7.8c0 .3.2.5.5.5h2.5c.3 0 .5-.2.5-.5V304c0-.2 0-.3-.2-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "M597.8 284.2c-.9.2-1.8.4-2.6.8-.1.2-.2.3-.3.5v8.2c0 .3.2.5.5.5h.3c.2 0 .4-.2.5-.4.1-.6.4-1.1.7-1.6s.8-.9 1.3-1.2c.2 0 .2-.2.2-.4v-5.8c0-.3-.3-.5-.6-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "m597.7 300.2-2.5 1.4c-.2 0-.2.2-.2.4v8.4c0 .3.2.5.5.5h2.5c.3 0 .5-.2.5-.5v-9.8c0-.4-.4-.6-.7-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "M601.7 298.3c-.4.2-.8.4-1.2.7l-1.3.7c-.2 0-.2.2-.2.4v10.3c0 .3.2.5.5.5h2.5c.3 0 .5-.2.5-.5v-11.7c0-.4-.4-.6-.7-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "M601.9 283.8c-.9 0-1.8.1-2.6.2-.2 0-.4.2-.4.5v6.2s.2 0 .3-.1c.8-.4 1.9-.5 3.2-.5v-5.8c0-.3-.2-.5-.5-.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "M631.1 284.2c-.8-.2-1.7-.3-2.6-.4-.3 0-.5.2-.5.5v5.8c0 .2.2.4.4.5.9.1 1.7.4 2.4.8.3.2.7 0 .7-.4v-6.3c0-.2-.2-.4-.4-.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "M630.8 303.9c-.7.4-1.5.7-2.4.8-.2 0-.4.2-.4.5v5.8c0 .3.2.5.5.5.9 0 1.8-.2 2.6-.4.2 0 .4-.2.4-.5v-6.3c0-.4-.4-.6-.7-.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "M632.6 284.5c-.3 0-.6.2-.6.5v6.7c0 .1 0 .3.2.4.1 0 .2.2.3.3 1.2 1.3 1.8 3 1.8 5.3s-.6 4.1-1.8 5.3c0 .1-.2.2-.3.3-.1 0-.2.2-.2.4v6.7c0 .3.3.5.6.5.9-.3 1.8-.6 2.6-1 0-.2.2-.3.3-.4V286c0-.2-.2-.3-.3-.4-.8-.4-1.7-.7-2.6-1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "M638.8 286c-1 .6-1.9 1.3-2.6 2.1 0 0-.1.2-.1.3v18.4c0 .1 0 .3.1.3.8.8 1.6 1.5 2.6 2.1.3.2.7 0 .7-.4v-22.4c0-.4-.4-.6-.7-.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "M642.8 289.2c-.3.4-.5.7-.8 1.1-1.3 2.1-1.9 4.5-1.9 7.3s.6 5.2 1.9 7.3c.2.4.5.8.8 1.1.3.4.9.2.9-.3v-16.2c0-.5-.6-.7-.9-.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st7",
    attrs: {
      "d": "M627 283.8h-2.6c-.2 0-.4.2-.4.5 0-.2-.3-.4-.5-.4-.9.1-1.8.3-2.6.6-.2 0-.3.2-.3.5v-.4c-.8.2-1.5.5-2.2.9-.5.2-.9.5-1.3.8-1 .6-1.8 1.3-2.5 2.1 0-.1-.2-.3-.3-.4-.2-.3-.4-.5-.7-.8-.9-.9-2.1-1.7-3.5-2.3v.3c-.1-.2-.2-.3-.3-.5-.8-.3-1.7-.6-2.6-.7-.3 0-.6.2-.6.5v-.2c0-.2-.2-.4-.4-.5-.8-.1-1.7-.2-2.6-.2l-.5.5v5.3c0 .3.2.5.5.5.8 0 1.4.2 2 .4.1 0 .2 0 .3.1.3.2.7 0 .7-.4v.6c0 .1 0 .3.2.4.1.1.3.2.4.4.4.5.5 1 .5 1.7s-.2 1.2-.6 1.7c-.1.1-.2.3-.4.4 0 0-.1.2-.1.3v.9c0-.4-.5-.6-.8-.4-.2.2-.4.3-.7.5-.5.3-1.1.7-1.8 1.1-.1 0-.2.2-.2.4v5.3c0 .4.4.6.7.4l1.1-.5c.5-.2 1-.5 1.5-.7.2 0 .3-.2.3-.4v-.5c0 .4.4.6.7.4.9-.5 1.8-1 2.6-1.4.1 0 .2-.2.2-.4v.3c.4-.2.7-.5 1-.7 0 0 .2-.1.2-.2.2 1.7.7 3.3 1.5 4.6h-2.8v.5c0-.3-.2-.5-.5-.5h-2.5c-.3 0-.5.2-.5.5 0-.3-.2-.5-.5-.5h-2.5c-.3 0-.5.2-.5.5v5.5c0 .3.2.5.5.5h2.5c.3 0 .5-.2.5-.5 0 .3.2.5.5.5h2.5c.3 0 .5-.2.5-.5v.5h6.5v-2.3c.2.1.4.2.5.4.4.3.8.5 1.3.8.7.4 1.4.6 2.2.9v-.4c0 .2.1.4.3.5.8.2 1.7.4 2.6.6.3 0 .5-.2.5-.5 0 .4.2.6.4.6h2.6c.3 0 .5-.2.5-.5v-5.7c0-.3-.2-.5-.5-.5h-.7c-.6 0-1.2 0-1.8-.2-.3 0-.6.2-.6.5v-.2c0-.2-.1-.4-.3-.5-1-.3-1.8-.8-2.5-1.5-.3-.3-.5-.5-.7-.8q-1.2-1.8-1.2-4.5c0-2.7.4-3.3 1.2-4.5.2-.3.4-.6.7-.8.7-.7 1.5-1.2 2.5-1.5.2 0 .3-.2.3-.5v-.2c0 .3.3.5.6.5.5-.1 1.1-.2 1.8-.2h.7c.3 0 .5-.2.5-.5V284c0-.3-.2-.5-.5-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "d": "m657 294-.4-.7c.3 0 .5-.2.8-.4.2-.1.4-.3.5-.6s.3-.6.4-1 .1-.9.2-1.5 0-1.3 0-2.2v-2.9h5.9v9.1h-.8v-8.4h-4.4v4.6c0 .7-.1 1.2-.3 1.7-.1.5-.3.8-.4 1.1s-.4.5-.6.7-.5.3-.8.4ZM666.9 293.8v-9.1h5.4v.7h-4.6v3.2h4.1v.7h-4.1v3.8h4.6v.7zM676.4 293.8v-8.4h-2.7v-.7h6.1v.7h-2.7v8.4h-.8ZM659.7 311.1c-.6 0-1.2 0-1.7-.3s-1-.4-1.3-.7l.5-.6c.3.3.7.5 1.1.7.5.2.9.3 1.5.3s1 0 1.4-.2.7-.4.9-.7.3-.6.3-1c0-.6-.2-1.1-.6-1.4s-1-.5-1.8-.5h-1.7v-.7h1.7c.4 0 .8 0 1.1-.2.3-.1.6-.4.8-.6.2-.3.3-.6.3-1s0-.7-.3-.9c-.2-.3-.4-.4-.8-.6s-.7-.2-1.2-.2-.9 0-1.3.2-.8.3-1.1.6l-.4-.6c.4-.3.8-.6 1.2-.7.5-.2 1-.3 1.6-.3s1.1 0 1.6.3c.4.2.8.5 1 .8.2.4.4.8.4 1.3s0 .6-.2.9-.4.5-.6.8c-.2.2-.5.4-.7.4.5.1.9.4 1.3.8s.5.9.5 1.6c0 .4-.1.9-.4 1.3q-.45.6-1.2.9c-.75.3-1.1.4-1.7.4ZM664 310.9l3.7-9.1h.6l3.8 9.1h-.8l-1-2.5h-4.4l-1 2.5h-.8Zm2.1-3.2h3.9l-2-4.8zM673.7 310.9v-9.1h5.2v.7h-4.5v3.2h1.9c.9 0 1.7.2 2.2.7.6.4.9 1.1.9 1.9s-.1 1-.4 1.4c-.2.4-.6.7-1.1.9s-1 .3-1.7.3h-2.7Zm.8-.7h2c.7 0 1.3-.2 1.7-.5s.6-.8.6-1.4-.2-1-.6-1.4c-.4-.3-1-.5-1.7-.5h-2zM685.8 311.1c-.7 0-1.3-.1-1.9-.4s-1.1-.6-1.5-1-.8-.9-1-1.5-.4-1.2-.4-1.9.1-1.3.4-1.9.6-1.1 1-1.5.9-.8 1.5-1 1.2-.4 1.9-.4 1.3.1 1.9.4c.6.2 1.1.6 1.5 1s.8.9 1 1.5.4 1.2.4 1.9-.1 1.3-.4 1.9c-.2.6-.6 1.1-1 1.5s-.9.8-1.5 1-1.2.4-1.9.4m0-.7c.5 0 1.1 0 1.5-.3.5-.2.9-.5 1.3-.8.4-.4.6-.8.8-1.3s.3-1 .3-1.6-.2-1.5-.5-2.1c-.4-.6-.8-1.1-1.4-1.4s-1.3-.5-2-.5-1.1 0-1.5.3-.9.5-1.3.8c-.4.4-.6.8-.8 1.3s-.3 1-.3 1.6.2 1.5.5 2.1c.4.6.8 1.1 1.4 1.4s1.3.5 2 .5M694.4 310.9v-8.4h-2.7v-.7h6.1v.7h-2.7v8.4h-.8ZM699.6 310.9v-9.1h.8v3.9h2.1c.6 0 1.2.1 1.6.3.5.2.8.5 1.1.9s.4.9.4 1.4 0 .8-.2 1.1c-.1.3-.3.6-.6.8s-.6.4-1 .5-.8.2-1.3.2zm.7-.7h2.2c.7 0 1.3-.2 1.7-.5s.6-.8.6-1.4-.2-1.1-.6-1.4-1-.5-1.7-.5h-2.2zm6.6.7v-9.1h.8v9.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#linear-gradient1)",
      "d": "M134.2 297.8c0 7.2 5.9 13.1 13.1 13.1h68.5V301h-68.5c-1.7 0-3.2-1.4-3.2-3.2s1.4-3.2 3.2-3.2h68.5v-9.9h-68.5c-7.2 0-13.1 5.9-13.1 13.1"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#linear-gradient2)",
      "d": "M219.2 294.7h7.4v16.2h9.9v-16.2h7.4v-10h-24.7z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#linear-gradient3)",
      "d": "M439.8 292.9h-10.7v-8.2h-9.9v26.2h9.9v-8.1h10.7v8.1h9.9v-26.2h-9.9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#linear-gradient4)",
      "d": "M315.9 284.7h-68.5v26.2h9.9v-16.2h58.6c1.7 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2h-52.3v9.9h52.3c7.2 0 13.1-5.9 13.1-13.1s-5.9-13.1-13.1-13.1Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#linear-gradient5)",
      "d": "M332.5 297.8c0 7.2 5.9 13.1 13.1 13.1h52.3V301h-52.3c-1.7 0-3.2-1.4-3.2-3.2s1.4-3.2 3.2-3.2h58.6v16.2h9.9v-26.2h-68.5c-7.2 0-13.1 5.9-13.1 13.1Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "url(#linear-gradient6)",
      "d": "M465.7 284.7c-7.2 0-13.1 5.9-13.1 13.1s5.9 13.1 13.1 13.1H518V301h-52.3c-1.7 0-3.2-1.4-3.2-3.2s1.4-3.2 3.2-3.2h58.6v16.2h9.9v-26.2h-68.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "d": "M560.4 284.7h1v26.2h-1z"
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };